"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardBadgeAreaMixin = void 0;
var _styledComponents = require("styled-components");
var _spaceMixin = require("../spaceMixin");
/** @class PropertyCardBadgeAreaMixin */
/** @method */
var PropertyCardBadgeAreaMixin = function PropertyCardBadgeAreaMixin(props) {
  return (0, _styledComponents.css)(["display:grid;grid-auto-flow:column;grid-column-gap:", ";align-items:start;"], (0, _spaceMixin.spaceMixin)(0.5)(props));
};
exports.PropertyCardBadgeAreaMixin = PropertyCardBadgeAreaMixin;